<div class="page-size-dropdown">
  <button
    type="button"
    class="page-size-toggle"
    (click)="toggleDropdown()"
    [class.active]="isOpen"
  >
    <span class="page-size-value">{{ selectedSize }}</span>
    <i
      class="fa-solid ms-2"
      [ngClass]="{
        'fa-chevron-down': !isOpen,
        'fa-chevron-up': isOpen,
      }"
    ></i>
  </button>

  <div class="page-size-dropdown-menu" *ngIf="isOpen">
    <button
      type="button"
      *ngFor="let size of reversedSizes"
      class="page-size-option"
      [class.active]="size === selectedSize"
      (click)="selectSize(size)"
    >
      {{ size }}
    </button>
  </div>
</div>
